import "./Home.css";
import React, { useState } from "react";
import SideBar from "../../Components/Organisms/Bars/SideBar/SideBar";
import NavBar from "../../Components/Organisms/Bars/NavBar/NavBar";
import { Link, Route, Routes } from "react-router-dom";
import { logoutURL } from "../../Hooks/URL";
import useLogout from "../../Hooks/useLogout";
import DashboardPage from "../../Pages/Dashboard/DashboardPage";
import SchoolsPage from "../../Pages/Schools/SchoolsPage";
import SchoolProfilePage from "../../Pages/Schools/SchoolProfilePage";
import AddSchoolPage from "../../Pages/Schools/AddSchoolPage";
import TeachersPage from "../../Pages/Teachers/TeachersPage";
import TeacherProfilePage from "../../Pages/Teachers/TeacherProfilePage";
import AddTeacherPage from "../../Pages/Teachers/AddTeacherPage";
import CoursesPage from "../../Pages/Courses/CoursesPage";
import CourseDetailsPage from "../../Pages/Courses/CourseDetailsPage";
import AddCoursePage from "../../Pages/Courses/AddCoursePage";
import AddSchoolToCoursePage from "../../Pages/Courses/AddSchoolToCoursePage";
import LessonDetailsPage from "../../Pages/Lessons/LessonDetailsPage";
import AddLessonPage from "../../Pages/Lessons/AddLessonPage";
import StudentsPage from "../../Pages/Students/StudentsPage";
import StudentProfilePage from "../../Pages/Students/StudentProfilePage";
import AddStudentPage from "../../Pages/Students/AddStudentPage";
import ClassesPage from "../../Pages/Classes/ClassesPage";
import ClassesDetailsPage from "../../Pages/Classes/ClassesDetailsPage";
import AddStudentsToClassPage from "../../Pages/Classes/AddStudentsToClassPage";
import AddClassPage from "../../Pages/Classes/AddClassPage";
import ClassSessionsPage from "../../Pages/Sessions/ClassSessionsPage";
import AddSessionPage from "../../Pages/Sessions/AddSessionPage";
import ClassSessionDetailsPage from "../../Pages/Sessions/ClassSessionDetailsPage";
import AddReportPage from "../../Pages/Reports/AddReportPage";
import ClassReportDetailsPage from "../../Pages/Reports/ClassReportDetailsPage";
import ClassFeedbackPage from "../../Pages/Reports/ClassFeedbackPage";
import ProfilePage from "../../Pages/Profile/ProfilePage";
import AddClassFeedbackPage from "../../Pages/Reports/AddClassFeedbackPage";

function Home() {
  const [showMenu, setShowMenu] = useState(false);
  const [goSave, setGoSave] = useState(false);
  const { saveState } = useLogout({
    url: logoutURL,
    goSave,
    setGoSave,
  });

  return (
    <div className="Home">
      <NavBar showMenu={showMenu} setShowMenu={setShowMenu} />
      <div className="container">
        <div className={`sidebar ${showMenu ? "sidebarOpen" : "sidebarClose"}`}>
          <SideBar setShowMenu={setShowMenu} />
        </div>
        <div className="main">
          <Routes>
            <Route path="/" element={<DashboardPage />} />
            <Route exact path="/schools" element={<SchoolsPage />} />
            <Route path="/schools/:id" element={<SchoolProfilePage />} />
            <Route path="/schools/add" element={<AddSchoolPage />} />
            <Route
              path="/schools/add/:id"
              element={<AddSchoolPage Edit={true} />}
            />
            <Route
              path="/schools/me"
              element={<AddSchoolPage EditSelf={true} />}
            />
            <Route path="/instructors" element={<TeachersPage />} />
            <Route path="/instructors/:id" element={<TeacherProfilePage />} />
            <Route path="/instructors/add" element={<AddTeacherPage />} />
            <Route
              path="/instructors/add/:id"
              element={<AddTeacherPage Edit={true} />}
            />
            <Route
              path="/instructors/me"
              element={<AddTeacherPage EditSelf={true} />}
            />
            <Route path="/programs" element={<CoursesPage />} />
            <Route path="/programs/:id" element={<CourseDetailsPage />} />
            <Route path="/programs/add" element={<AddCoursePage />} />
            <Route
              path="/programs/add/:id"
              element={<AddCoursePage Edit={true} />}
            />
            <Route
              path="/programs/:id/attributes"
              element={<AddCoursePage Edit={true} attributesEdit={true} />}
            />
            <Route
              path="/programs/assign/:id"
              element={<AddSchoolToCoursePage />}
            />
            <Route
              path="/programs/:id/lessons/:lesson_id"
              element={<LessonDetailsPage />}
            />
            <Route
              path="/programs/:id/lessons/add"
              element={<AddLessonPage />}
            />
            <Route
              path="/programs/:id/lessons/add/:lesson_id"
              element={<AddLessonPage Edit={true} />}
            />
            <Route path="/students" element={<StudentsPage />} />
            <Route path="/students/:id" element={<StudentProfilePage />} />
            <Route path="/students/add" element={<AddStudentPage />} />
            <Route
              path="/students/add/:id"
              element={<AddStudentPage Edit={true} />}
            />
            <Route path="/classes" element={<ClassesPage />} />
            <Route path="/classes/:id" element={<ClassesDetailsPage />} />
            <Route
              path="/classes/:id/enroll"
              element={<AddStudentsToClassPage />}
            />
            <Route path="/classes/add" element={<AddClassPage />} />
            <Route
              path="/classes/add/:id"
              element={<AddClassPage Edit={true} />}
            />
            <Route
              path="/classes/:id/sessions"
              element={<ClassSessionsPage />}
            />
            <Route
              path="/classes/:id/sessions/add"
              element={<AddSessionPage />}
            />
            <Route
              path="/classes/:id/sessions/add/:session_id"
              element={<AddSessionPage Edit={true} />}
            />
            <Route
              path="/classes/:id/sessions/:session_id"
              element={<ClassSessionDetailsPage />}
            />
            <Route
              path="/classes/:id/reports/:report_id"
              element={<ClassReportDetailsPage />}
            />
            <Route
              path="/classes/:id/reports/add"
              element={<AddReportPage />}
            />
            <Route
              path="/classes/:id/reports/add/:report_id"
              element={<AddReportPage Edit={true} />}
            />
            <Route
              path="/classes/:id/reports/:report_id/student/:student_id/feedback/:feedback_id"
              element={<ClassFeedbackPage />}
            />
            <Route
              path="/classes/:id/reports/:report_id/student/:student_id/feedback/:feedback_id/edit"
              element={<AddClassFeedbackPage Edit={true} />}
            />
            <Route
              path="/classes/:id/reports/:report_id/student/:student_id/add"
              element={<AddClassFeedbackPage />}
            />
            <Route path="/account" element={<ProfilePage />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default Home;
